import { routes as listingRoutes } from './listings'
import { routes as propRentalRoutes } from './prop-rentals'
import { routes as rentalOwnerRoutes } from './rental-owner'

export const routes = {
  ...listingRoutes,
  ...propRentalRoutes,
  ...rentalOwnerRoutes,
}
